import { MailReceivedFromDTO } from "../../models/mail-received-from/mail-received-from-dto";
import { BaseApiService } from "../base";
import { MailReceivedFromSTO } from "../../models/mail-received-from/mail-received-from-sto";

export class MailReceivedFromApiService extends BaseApiService<MailReceivedFromDTO, MailReceivedFromSTO> {
  constructor() {
    super({
      servicePath: "/MailreceivedFrom",
      loadItemsPath: "/GetMailreceivedFrom",
      saveItemsPath: "/SaveMailReceivedFrom",
    });
  }
}
